import { createContext, useContext, useEffect, useState } from "react";
import { STRINGS } from "./strings";

const LangContext = createContext(null);

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("lf-lang") || "it");
  useEffect(() => {
    localStorage.setItem("lf-lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);
  return <LangContext.Provider value={{ lang, setLang, t: STRINGS[lang] }}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);
